// extracted by mini-css-extract-plugin
export var arrow = "_3k-6";
export var changeItem = "_3k-3";
export var changesHeader = "_3k-1";
export var changesList = "_3k-2";
export var container = "_3k-0";
export var pathLabel = "_3k-4";
export var value = "_3k-7";
export var valuesContainer = "_3k-5";